export class IndicatorSetParam {
  idIndicatorSet: number;
  idIndicatorParam: number;
  value: string;

  constructor(idIndicatorSet: number, idIndicatorParam: number, value: string) {
    this.idIndicatorSet = idIndicatorSet;
    this.idIndicatorParam = idIndicatorParam;
    this.value = value;
  }

  static fromRaw(raw: any): IndicatorSetParam {
    return new IndicatorSetParam(
      raw.idIndicatorSet,
      raw.idIndicatorParam,
      String(raw.value ?? ''),
    );
  }

  clone(): IndicatorSetParam {
    return new IndicatorSetParam(
      this.idIndicatorSet,
      this.idIndicatorParam,
      this.value,
    );
  }
}

export class IndicatorSet {
  idIndicatorSet: number;
  idIndicator: number;
  locked: boolean;
  values: IndicatorSetParam[];

  constructor(
    idIndicatorSet: number,
    idIndicator: number,
    locked: boolean,
    values: IndicatorSetParam[] = [],
  ) {
    this.idIndicatorSet = idIndicatorSet;
    this.idIndicator = idIndicator;
    this.locked = locked;
    this.values = values;
  }

  static fromRaw(raw: any): IndicatorSet {
    let values: IndicatorSetParam[] = [];
    if (Array.isArray(raw.values)) {
      values = raw.values.map((param: any) => IndicatorSetParam.fromRaw(param));
    } else if (raw.values && typeof raw.values === 'object') {
      values = Object.entries(raw.values).map(([idIndicatorParam, value]) =>
        new IndicatorSetParam(
          raw.idIndicatorSet,
          Number(idIndicatorParam),
          String(value)
        )
      );
    }
    return new IndicatorSet(
      raw.idIndicatorSet,
      raw.idIndicator,
      Boolean(raw.locked),
      values,
    );
  }

  clone(): IndicatorSet {
    return new IndicatorSet(
      this.idIndicatorSet,
      this.idIndicator,
      this.locked,
      this.values.map(p => p.clone()),
    );
  }

  toPayload(): any {
    const payload: any = {
      idIndicator: this.idIndicator,
      locked: this.locked,
      values: this.values.map(p => ({
        idIndicatorSet: p.idIndicatorSet,
        idIndicatorParam: p.idIndicatorParam,
        value: p.value,
      })),
    };
    if (this.idIndicatorSet !== 0) {
      payload.idIndicatorSet = this.idIndicatorSet;
    }
    return payload;
  }
}
